import React from "react"

class Dashboard extends React.Component {
	render() {
		return <div className="mioto-layout" style={{height: "100vh"}}>
				<div className="cover" />
				<div className="ibox login-content">
					<div className="text-center"><span className="auth-head-icon"><i className="la la-user" /></span></div>
					<form className="ibox-body" id="login-form" action="javascript:;" method="POST">
						<h4 className="font-strong text-center mb-5">LOG IN</h4>
						<div className="form-group mb-4">
							<input className="form-control form-control-line" type="text" name="email" placeholder="Email" />
						</div>
						<div className="form-group mb-4">
							<input className="form-control form-control-line" type="password" name="password" placeholder="Password" />
						</div>
						<div className="flexbox mb-5"><span>
								<label className="ui-switch switch-icon mr-2 mb-0">
									<input type="checkbox" defaultChecked /><span />
								</label>Remember</span><a className="text-primary" href="forgot_password.html">Forgot password?</a></div>
						<div className="text-center mb-4">
							<button className="btn btn-primary btn-rounded btn-block">LOGIN</button>
						</div>
					</form>
				</div>
				{/* BEGIN PAGA BACKDROPS*/}
				{/* <div className="sidenav-backdrop backdrop" />
				<div className="preloader-backdrop">
					<div className="page-preloader">Loading</div>
				</div> */}
			</div>
	}
}

export default Dashboard


// WEBPACK FOOTER //
// ./src/components/login/login.js